import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

import { Layout } from "@/components/layout/Layout";
import { ScrollToTop } from "@/components/layout/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import DigitalDentistry from "@/pages/DigitalDentistry";
import Doctors from "@/pages/Doctors";
import DoctorProfile from "@/pages/DoctorProfile";
import OralCancerCentre from "@/pages/OralCancerCentre";
import InternationalPatients from "@/pages/InternationalPatients";
import PatientStories from "@/pages/PatientStories";
import BeforeAfter from "@/pages/BeforeAfter";
import Knowledge from "@/pages/Knowledge";
import ArticleDetail from "@/pages/ArticleDetail";
import Videos from "@/pages/Videos";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Appointment from "@/pages/Appointment";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={withLayout(<Home />)} />
            <Route path="/about" element={withLayout(<About />)} />
            <Route path="/services" element={withLayout(<Services />)} />
            <Route path="/services/:slug" element={withLayout(<ServiceDetail />)} />
            <Route path="/digital-dentistry" element={withLayout(<DigitalDentistry />)} />
            <Route path="/doctors" element={withLayout(<Doctors />)} />
            <Route path="/doctors/:slug" element={withLayout(<DoctorProfile />)} />
            <Route path="/oral-cancer-centre" element={withLayout(<OralCancerCentre />)} />
            <Route path="/international-patients" element={withLayout(<InternationalPatients />)} />
            <Route path="/patient-stories" element={withLayout(<PatientStories />)} />
            <Route path="/before-after" element={withLayout(<BeforeAfter />)} />
            <Route path="/knowledge" element={withLayout(<Knowledge />)} />
            <Route path="/knowledge/:slug" element={withLayout(<ArticleDetail />)} />
            <Route path="/videos" element={withLayout(<Videos />)} />
            <Route path="/faq" element={withLayout(<Faq />)} />
            <Route path="/contact" element={withLayout(<Contact />)} />
            <Route path="/appointment" element={withLayout(<Appointment />)} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={withLayout(<NotFound />)} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
